module.exports = __webpack_public_path__ + "media/img/frontend_application/navicon/white-notif-icon-4b7e84cd45ef235baf6f67ac5545331d.svg";